exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li._32AIy{width:100px;margin-bottom:1px}li._32AIy a{display:block;margin-left:-45px;-webkit-transition:margin-left .2s;-o-transition:margin-left .2s;transition:margin-left .2s;width:100px;height:51px;background-color:#f40000;background-repeat:no-repeat;background-position:45px;cursor:pointer}li._32AIy a:hover{margin-left:-30px}", ""]);

// exports
exports.locals = {
	"datosIco": "_32AIy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/LeftNavigationButton/LeftNavigationButton.css
// module id = 1035
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13